import { api, writeDB } from './store';

export interface StorageLocation {
  id: string;
  slug: string;
  location: string;
  row: string;
  field: string;
  floor: string;
  description: string;
  name: string;
  created_at: Date;
  updated_at: Date;
}

export async function getStorageLocations(): Promise<void> {
  const response = await api.indexStorages();
  writeDB.table('storageLocations').upsert(response.data);
}
